import {
  CREATE_ORGAN_FAIL,
  CREATE_ORGAN_REQUEST,
  CREATE_ORGAN_SUCCESS,
  CREATE_SURGERY_FAIL,
  CREATE_SURGERY_REQUEST,
  CREATE_SURGERY_SUCCESS,
  CREATE_TYPE_SURGERY_FAIL,
  CREATE_TYPE_SURGERY_REQUEST,
  CREATE_TYPE_SURGERY_SUCCESS,
  FETCH_ORGAN_FAIL,
  FETCH_ORGAN_REQUEST,
  FETCH_ORGAN_SUCCESS,
  FETCH_SURGERY_FAIL,
  FETCH_SURGERY_REQUEST,
  FETCH_SURGERY_SUCCESS,
  FETCH_TYPE_SURGERY_FAIL,
  FETCH_TYPE_SURGERY_REQUEST,
  FETCH_TYPE_SURGERY_SUCCESS,
  GET_SURGERY_BY_IDS_FAIL,
  GET_SURGERY_BY_IDS_REQUEST,
  GET_SURGERY_BY_IDS_SUCCESS,
  SHOW_ORGAN_FAIL,
  SHOW_ORGAN_REQUEST,
  SHOW_ORGAN_SUCCESS,
  SHOW_TYPE_SURGERY_FAIL,
  SHOW_TYPE_SURGERY_REQUEST,
  SHOW_TYPE_SURGERY_SUCCESS,
  UPDATE_ORGAN_FAIL,
  UPDATE_ORGAN_REQUEST,
  UPDATE_ORGAN_SUCCESS,
  UPDATE_SURGERY_FAIL,
  UPDATE_SURGERY_REQUEST,
  UPDATE_SURGERY_SUCCESS,
  UPDATE_TYPE_SURGERY_FAIL,
  UPDATE_TYPE_SURGERY_REQUEST,
  UPDATE_TYPE_SURGERY_SUCCESS,
} from "../../ActionType/SurgeryType/SurgeryType";

export const getSurgeryReducer = (
  state = { loading: true, surgeries: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_SURGERY_REQUEST:
      return {
        loading: true,
      };
    case FETCH_SURGERY_SUCCESS:
      return {
        loading: false,
        surgeries: action.payload,
        error: "",
      };
    case FETCH_SURGERY_FAIL:
      return {
        loading: false,
        surgeries: action.payload,
        erorr: action.error,
      };
    default:
      return state;
  }
};

export const createSurgeryReducer = (
  state = { loading: true, surgeries: [], error: [] },
  action
) => {
  switch (action.type) {
    case CREATE_SURGERY_REQUEST:
      return {
        loading: true,
      };
    case CREATE_SURGERY_SUCCESS:
      return {
        loading: false,
        surgeries: action.payload,
        error: "",
      };
    case CREATE_SURGERY_FAIL:
      console.log(action.error);
      return {
        loading: false,
        surgeries: action.payload,
        error: action.error,
      };
    default:
      return state;
  }
};

export const updateSurgeryReducer = (
  state = { loading: true, surgeries: [], error: "" },
  action
) => {
  switch (action.type) {
    case UPDATE_SURGERY_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_SURGERY_SUCCESS:
      return {
        loading: false,
        surgeries: action.payload,
        error: "",
      };
    case UPDATE_SURGERY_FAIL:
      return {
        loading: false,
        surgeries: action.payload,
        erorr: action.error,
      };
    default:
      return state;
  }
};

export const createTypeSurgeryReducer = (
  state = { loading: true, typeSurgeries: [], error: [] },
  action
) => {
  switch (action.type) {
    case CREATE_TYPE_SURGERY_REQUEST:
      return {
        loading: true,
      };
    case CREATE_TYPE_SURGERY_SUCCESS:
      return {
        loading: false,
        typeSurgeries: action.payload,
        error: "",
      };
    case CREATE_TYPE_SURGERY_FAIL:
      return {
        loading: false,
        typeSurgeries: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const getTypeSurgeryReducer = (
  state = { loading: true, typeSurgeries: [], error: [] },
  action
) => {
  switch (action.type) {
    case FETCH_TYPE_SURGERY_REQUEST:
      return {
        loading: true,
      };
    case FETCH_TYPE_SURGERY_SUCCESS:
      return {
        loading: false,
        typeSurgeries: action.payload,
        error: "",
      };
    case FETCH_TYPE_SURGERY_FAIL:
      return {
        loading: false,
        typeSurgeries: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const updateTypeSurgeryReducer = (
  state = { loading: true, typeSurgeries: [], error: [] },
  action
) => {
  switch (action.type) {
    case UPDATE_TYPE_SURGERY_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_TYPE_SURGERY_SUCCESS:
      return {
        loading: false,
        typeSurgeries: action.payload,
        error: "",
      };
    case UPDATE_TYPE_SURGERY_FAIL:
      return {
        loading: false,
        typeSurgeries: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const createOrganReducer = (
  state = { loading: true, organs: [], error: [] },
  action
) => {
  switch (action.type) {
    case CREATE_ORGAN_REQUEST:
      return {
        loading: true,
      };
    case CREATE_ORGAN_SUCCESS:
      return {
        loading: false,
        organs: action.payload,
        error: "",
      };
    case CREATE_ORGAN_FAIL:
      return {
        loading: false,
        organs: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const getOrganReducer = (
  state = { loading: true, organs: [], error: [] },
  action
) => {
  switch (action.type) {
    case FETCH_ORGAN_REQUEST:
      return {
        loading: true,
      };
    case FETCH_ORGAN_SUCCESS:
      return {
        loading: false,
        organs: action.payload,
        error: "",
      };
    case FETCH_ORGAN_FAIL:
      return {
        loading: false,
        organs: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const showTypeSurgeryReducer = (
  state = { loading: true, typeSurgeries: [], error: [] },
  action
) => {
  switch (action.type) {
    case SHOW_TYPE_SURGERY_REQUEST:
      return {
        loading: true,
      };
    case SHOW_TYPE_SURGERY_SUCCESS:
      return {
        loading: false,
        typeSurgeries: action.payload,
        error: "",
      };
    case SHOW_TYPE_SURGERY_FAIL:
      return {
        loading: false,
        typeSurgeries: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const getSurgeryByIdsReducer = (
  state = { loading: true, surgeriesById: [], error: [] },
  action
) => {
  switch (action.type) {
    case GET_SURGERY_BY_IDS_REQUEST:
      return {
        loading: true,
      };
    case GET_SURGERY_BY_IDS_SUCCESS:
      return {
        loading: false,
        surgeriesById: action.payload,
        error: "",
      };
    case GET_SURGERY_BY_IDS_FAIL:
      return {
        loading: false,
        surgeriesById: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export const updateOrganReducer = (
  state = { loading: true, organs: [], error: [] },
  action
) => {
  switch (action.type) {
    case UPDATE_ORGAN_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_ORGAN_SUCCESS:
      return {
        loading: false,
        organs: action.payload,
        error: "",
      };
    case UPDATE_ORGAN_FAIL:
      return {
        loading: false,
        organs: [],
        error: action.error,
      };
    default:
      return state;
  }
};


export const showOrganReducer = (
  state = { loading: true, organs: [], error: [] },
  action
) => {
  switch (action.type) {
    case SHOW_ORGAN_REQUEST:
      return {
        loading: true,
      };
    case SHOW_ORGAN_SUCCESS:
      return {
        loading: false,
        organs: action.payload,
        error: "",
      };
    case SHOW_ORGAN_FAIL:
      return {
        loading: false,
        organs: [],
        error: action.error,
      };
    default:
      return state;
  }
};